import { Link } from 'react-router-dom';
import ComicCard from '@/components/feature/ComicCard';
import { comics } from '@/mocks/comics';

export default function LatestUpdates() {
  const latestComics = comics
    .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
    .slice(0, 8);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100/70">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
              最新更新
            </h2>
            <p className="text-xs md:text-sm text-foreground-500 mt-1">
              刚刚更新的漫画章节
            </p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            全部漫画
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5" data-product-shop>
          {latestComics.map((comic) => (
            <div key={comic.id} className="flex justify-center">
              <ComicCard comic={comic} size="small" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}